"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUserFavoritesForProduct;

var _react = _interopRequireDefault(require("react"));

var _useUserFavoritesContext = _interopRequireDefault(require("../useUserFavoritesContext"));

function useUserFavoritesForProduct(product) {
  var _useUserFavoritesCont = (0, _useUserFavoritesContext.default)(),
      addToUserFavorites = _useUserFavoritesCont.addToUserFavorites,
      removeFromUserFavorites = _useUserFavoritesCont.removeFromUserFavorites,
      userFavorites = _useUserFavoritesCont.userFavorites;

  var isFavorite = userFavorites.includes(product.id);

  var handleAdd = _react.default.useCallback(function () {
    addToUserFavorites([product.id]);
  }, [addToUserFavorites, product.id]);

  var handleRemove = _react.default.useCallback(function () {
    removeFromUserFavorites([product.id]);
  }, [product.id, removeFromUserFavorites]);

  return {
    isFavorite: isFavorite,
    handleAdd: handleAdd,
    handleRemove: handleRemove
  };
}